import { render } from "./haircolorDiagTip.vue?vue&type=template&id=2a16b5fd"
import script from "./haircolorDiagTip.vue?vue&type=script&lang=js"
export * from "./haircolorDiagTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__